import { useSelector } from 'react-redux'
import { IStore } from '../interfaces/Store'

type Journey = 'MR' | 'LR' | 'HR'

const useGetJourneyType = () => {
  const folder = useSelector(
    (stateReducer: IStore) => stateReducer.folderReducer.folder
  )

  return {
    journeyType: folder?.score_secu_fin as Journey,
  }
}

export default useGetJourneyType
